import { Fragment } from "react";
import { TableCell, TableRow, Typography } from "@material-ui/core";

const DesktopDetail = ({ device }) => {
  return (
    <Fragment>
      <TableRow>
        <TableCell>
          <Typography color="textPrimary" variant="subtitle2">
            Serial Number
          </Typography>
        </TableCell>
        <TableCell>{device["SystemInfo.Serial"]}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell>
          <Typography color="textPrimary" variant="subtitle2">
            Make
          </Typography>
        </TableCell>
        <TableCell>{device["SystemInfo.Make"]}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell>
          <Typography color="textPrimary" variant="subtitle2">
            Model
          </Typography>
        </TableCell>
        <TableCell>{device["SystemInfo.Model"]}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell>
          <Typography color="textPrimary" variant="subtitle2">
            CPU
          </Typography>
        </TableCell>
        <TableCell>{device["BasicComponent.CpuTitle"]}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell>
          <Typography color="textPrimary" variant="subtitle2">
            Storage Size
          </Typography>
        </TableCell>
        <TableCell>{device["BasicComponent.StorageAmount"]}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell>
          <Typography color="textPrimary" variant="subtitle2">
            Storage Type
          </Typography>
        </TableCell>
        <TableCell>{device["MiscHardware.storageType"]}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell>
          <Typography color="textPrimary" variant="subtitle2">
            Memory Size
          </Typography>
        </TableCell>
        <TableCell>{device["BasicComponent.RamTitle"]}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell>
          <Typography color="textPrimary" variant="subtitle2">
            Memory Type
          </Typography>
        </TableCell>
        <TableCell>{device["BasicComponent.memoryType"]}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell>
          <Typography color="textPrimary" variant="subtitle2">
            Memory Speed
          </Typography>
        </TableCell>
        <TableCell>{device["BasicComponent.memorySpeed"]}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell>
          <Typography color="textPrimary" variant="subtitle2">
            Video Card
          </Typography>
        </TableCell>
        <TableCell>{device["BasicComponent.gpu"]}</TableCell>
      </TableRow>
    </Fragment>
  );
};

export default DesktopDetail;
